// import React, { useState } from "react";
// import { Carousel } from "react-bootstrap";

// const redastor ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/ASTOR%2Fredastor.webp?alt=media&token=52e953c2-0cb3-4b96-a115-246844df359c"
// const whitehect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/ASTOR%2Fwhite.webp?alt=media&token=22b138e2-65a7-43ec-b27a-e1ee65cce85c"
// const greyhect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/ASTOR%2Fgreyhect.webp?alt=media&token=54953aa3-1e4d-493e-8d7a-1a066442d58f"
// const whiteblackhect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/ASTOR%2FwhiteblackhectA.webp?alt=media&token=5a8b6e87-d441-444a-93a9-abb79ed43451"
// const blackhect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/ASTOR%2Fblack.webp?alt=media&token=76fb745a-2067-4db6-a0a9-6ba79eb4b96f"
// const  silverhect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/ASTOR%2Fsilverhect.webp?alt=media&token=99bdd3ce-77be-4f13-b50e-25d401117821"
// const CustomCarousel = () => {
//   const [activeIndex, setActiveIndex] = useState(null);
//   const [fixedImage, setFixedImage] = useState(redastor); 

//   const carImages = [
//     { src: redastor, alt: "redastor", color: "#F64752" },
//     // { src: yellowhect, alt: "yellowhector", color: "#594B3F" },
//     { src: whitehect, alt: "Whitehector", color: "#FFF" },
//     { src: greyhect, alt: "greyhector", color: "#3D3941" },
//     { src: whiteblackhect, alt: "white-blackhector", color: "#E9E9E9" },
//     { src: blackhect, alt: "blackhector", color: "black" },
//     { src: silverhect, alt: "silverhector", color: "#A1A4AD" },
//   ];

//   const handleSelect = (index) => {
//     setActiveIndex(index);
//     setFixedImage(carImages[index].src); 
//   };

//   return (
//     <div style={{ position: "relative",margin:0,padding:0 ,height:"90vh"}}>
//       <Carousel 
//         activeIndex={activeIndex} 
//         onSelect={handleSelect} 
//         interval={null} 
//         pause={false}
//         indicators={false}
//         controls={false}
//       >
//         {carImages.map((car, index) => (
//           <Carousel.Item key={index}>
//             <img className="d-block w-100" src={fixedImage} alt={car.alt} />
//           </Carousel.Item>
//         ))}
//       </Carousel>

//       {/* Custom Circle Indicators */}
//       <div style={{ position: "absolute", left: "50%",top:"47%", transform: "translateX(-50%)", display: "flex", gap: "12px" }}>
//         {carImages.map((car, index) => (
//           <div
//             key={index}
//             onClick={() => handleSelect(index)}
//             style={{
              
//               width: "23px",
//               height: "24px",
//               borderRadius: "50%",
//               backgroundColor: activeIndex === index ? car.color : car.color, 
//               cursor: "pointer",
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CustomCarousel;
























import React, { useState } from "react";
import { Carousel } from "react-bootstrap";

const redastor ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-0338.webp?alt=media&token=bd016ba1-d58d-4fdf-8a90-425c9c237409"
const whitehect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-0339.webp?alt=media&token=d7dc5717-372f-49c2-8cf5-bdb02007b11b"
const greyhect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-0340.webp?alt=media&token=22de2628-e18b-4415-a3b4-f505a8807b5c"
const whiteblackhect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-0341.webp?alt=media&token=57754854-b443-4626-8339-b2927b7d49f0"
const blackhect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-0339.webp?alt=media&token=d7dc5717-372f-49c2-8cf5-bdb02007b11b"
const silverhect ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-0343.webp?alt=media&token=b0e21f94-3bc2-4c2a-91cd-2f00e00e87c6"

const CustomCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [fixedImage, setFixedImage] = useState(redastor); 

  const carImages = [
    { src: redastor, alt: "redastor", color: "#F64752" },
    { src: whitehect, alt: "Whitehector", color: "#FFF" },
    { src: greyhect, alt: "greyhector", color: "#3D3941" },
    { src: whiteblackhect, alt: "white-blackhector", color: "#E9E9E9" },
    { src: blackhect, alt: "blackhector", color: "black" },
    { src: silverhect, alt: "silverhector", color: "#A1A4AD" },
  ];

  const handleSelect = (index) => {
    setActiveIndex(index);
    setFixedImage(carImages[index].src); 
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Carousel 
        activeIndex={activeIndex} 
        onSelect={handleSelect} 
        interval={null} 
        pause={false}
        indicators={false}
        controls={false}
      >
        {carImages.map((car, index) => (
          <Carousel.Item key={index}>
            <div
              style={{
                height: "80vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <img
                src={fixedImage}
                alt={car.alt}
                style={{
                  maxHeight: "80vh",
                  width: "100%",
                  objectFit: "contain"
                }}
              />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Custom Indicators */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          bottom: "60px",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "12px",
        }}
      >
        {carImages.map((car, index) => (
          <div
            key={index}
            onClick={() => handleSelect(index)}
            style={{
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              backgroundColor: car.color,
              cursor: "pointer",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomCarousel;